import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant'
import { createPinia } from 'pinia'
import '../src/assets/css/reset.css'
import 'vant/lib/index.css'
import '../src/assets/js/rem.min.js'
import 'animate.css';
import Vconsole from 'vconsole'
import { Toast } from 'vant'

//道勤
import { ds } from '../src/assets/js/ds.js'
import { util } from '../src/assets/js/utils.js'

const pinia = createPinia()
const app = createApp(App)
// let vConsole = new Vconsole()
// app.use(vConsole)


let paramUrl = decodeURIComponent(window.location.href)
if (paramUrl.indexOf('target=') != -1) {
  //道勤
  ds.getTicketFunc(paramUrl, app, [store, router, Vant])
    .then((result) => {
      localStorage.setItem('is_dq', 1)
      let res = result.sign
      let mark = ''
      let path = ''
      let token = ''
      let w_token = ''
      let wechat = ''
      if (paramUrl.indexOf('path=') != -1) {
        let urlData = util.getUrlkey(paramUrl)
        path = urlData['path']
        if (urlData['wechat']) {
          wechat = urlData['wechat']
        }
        mark = 'workbench'
        token = result.token
      } else {
        wechat = ''
        mark = 'waimai'
        token = res.token
        w_token = result.token
      }
      router.replace({
        path: '/index',
        query: {
          w_token: w_token,
          token: token,
          emp_code: res.emp_code,
          employee_code: res.employee_code,
          employee_name: res.employee_name,
          brand_code: res.brand_code,
          source: res.source,
          sign: res.sign,
          mark: mark,
          path: path,
          wechat,
        },
      })
    })
    .catch((err) => {
      Toast(err.msg || err.message)
    })
} else {
  localStorage.setItem('is_dq', 0)
  app.use(store).use(router).use(Vant).use(pinia).mount('#app')
}
